<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      :ordenar-nomes="['Nome', 'CPF', 'Data de Nascimento']"
      :ordenar-por="['nome', 'cpf', 'data_nascimento']"
      @ordenar="ordenar"
      @pesquisar="pesquisar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <CampoNome :valor="filtro.nome" @atualizar="filtro.nome = $event" />
          </div>
          <div class="form-group col-xs-12 col-sm-12 col-md-4 col-lg-4">
            <CampoNomeSocial
              :valor="filtro.nome_social"
              @atualizar="filtro.nome_social = $event"
            />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-2 col-lg-2">
            <CampoCpf
              :valor="filtro.cpf"
              :validacao="v$.filtro.cpf"
              @atualizar="filtro.cpf = $event"
            >
              <template #mensagensValidacao>
                <p v-if="!v$.filtro.cpf.cpfValido">CPF inválido.</p>
              </template>
            </CampoCpf>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <SelecionarData
              id="inicioDataNascimento"
              label="Início Data de Nascimento"
              :valor="filtro.inicioDataNascimento"
              @atualizar="filtro.inicioDataNascimento = $event"
            />
          </div>
          <div class="col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <SelecionarData
              id="fimDataNascimento"
              label="Fim Data de Nascimento"
              :valor="filtro.fimDataNascimento"
              @atualizar="filtro.fimDataNascimento = $event"
            />
          </div>
          <div class="form-group col-xs-12 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela><PacienteTabela :pacientes="pacientes" /></template>
      <template #fichas>
        <div
          v-for="paciente in pacientes"
          :key="paciente._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <PacienteFicha :paciente="paciente" />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoCpf from '@/componentes/formulario/CampoCpf'
import CampoNome from '@/componentes/formulario/CampoNome'
import CampoNomeSocial from '@/componentes/formulario/CampoNomeSocial'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import PacienteServico from '@/servicos/PacienteServico'
import CpfValidador from '@/validadores/Cpf'

import PacienteFicha from './PacienteFicha'
import PacienteTabela from './PacienteTabela'

const cpfValidador = new CpfValidador()

export default {
  components: {
    PacienteFicha,
    PacienteTabela,
    BlocoFiltroPesquisa,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
    CampoNome,
    CampoNomeSocial,
    CampoCpf,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const pacientes = ref([])
    const servico = new PacienteServico()
    const nomeResultado = 'pacientes'
    const nomeDoForm = 'PacienteForm'
    const filtro = ref({
      nome: '',
      cpf: '',
      inicioDataNascimento: '',
      fimDataNascimento: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: pacientes,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(6)
    return {
      pacientes,
      servico,
      filtro,
      ...pesquisa,
      v$: useVuelidate(),
    }
  },

  validations: {
    filtro: {
      cpf: {
        cpfValido(cpf) {
          return cpfValidador.valido(cpf)
        },
      },
    },
  },
}
</script>
